import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosRegular } from '../../style/theme';

export const StyledShowpadCodeContainer = styled.div`
    margin-bottom: 4rem;
    background: ${theme.palette.lightBeige};
    padding: 2rem 3rem;
    border-radius: ${theme.borderRadius.large};
    max-width: 50rem;

    ${theme.containerQueries.mobileMax} {
        margin-bottom: 2rem;
        padding: 1rem 2rem;
        border-radius: ${theme.borderRadius.small};
    }
`;

export const StyledFieldContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-block: 1rem;
    flex-direction: column;
`;

export const StyledErrorMessage = styled.div`
    color: ${theme.colors.text.pink};
    font-size: 16px;
    font-family: ${fontFamilyAtosRegular};
`;

